import React, { Component } from "react";import {
params,
  loading,
  tokens,
  locale,
  Modal,
  required,
  float
} from "./CustomComponent.js";
import "../assets/css/bootstrap.css";
import LOGO from "../assets/images/logo.png";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_product: [],

      name_contact_1: "",
      address_contact_1: "",
      phone_contact_1: "",
      fax_contact_1: "",
      email_contact_1: "",
      website_contact_1: "",
    };
  }
  componentDidMount = async () => {
    loading(false);
      this.Get();
  };
  Get = async () => {
    loading(true);let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
    let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
    result = await response.json();
    localStorage.setItem("scp-acc-tk", JSON.stringify(result));}else{
      result = tokens;
    }
    this.setState({
      data_product: (result?.product ? Object.values(result?.product) : [])?.sort(() => Math.random() - 0.5)?.slice(0, 6),

            name_contact_1:
              result?.setting[`${locale}_name_contact_1`] ||
              result?.setting?.th_name_contact_1,
            address_contact_1:
              result?.setting[`${locale}_address_contact_1`] ||
              result?.setting?.th_address_contact_1,
            phone_contact_1:
              result?.setting[`${locale}_phone_contact_1`] ||
              result?.setting?.th_phone_contact_1,
            fax_contact_1:
              result?.setting[`${locale}_fax_contact_1`] ||
              result?.setting?.th_fax_contact_1,
            email_contact_1:
              result?.setting[`${locale}_email_contact_1`] ||
              result?.setting?.th_email_contact_1,
            website_contact_1:
              result?.setting[`${locale}_website_contact_1`] ||
              result?.setting?.th_website_contact_1,
    });
    loading(false);
  };
  render() {
    const {
      name_contact_1,
address_contact_1,
phone_contact_1,
fax_contact_1,
email_contact_1,
website_contact_1} = this.state;
    return (
      <div>
        <div className="d-block d-sm-none hpx-280"></div>
        <div className="d-block d-lg-none hpx-280"></div>
        <div className="hpx-280"></div>
      <div
        className="w-100 px-3 py-2 bg-white text-secondary position-absolute"
        style={{ left: 0, bottom: 0 }}
      >
        <div className="row mt-3">
          <div className="col-12 col-sm-6 col-lg-3 mb-2">
            <button
              className="btn btn-link px-1"
              onClick={() => {
                  window.location.href= "/";
              }}
            >
              <img
                alt="LOGO"
                src={LOGO}
                width={50}
                style={{ objectFit: "contain" }}
              />
            </button>
            <br/>
            <small>
              เรามุ่งเน้นผลิตเตาเผาที่เป็นมิตรกับสิ่งแวดล้อม และสโลแกนของเราคือ “ใส่ใจสิ่งแวดล้อมอย่างแท้จริง”
            </small>
          </div>
          <div className="col-12 col-sm-6 col-lg-2 mb-2">
            <h5 className="mb-2 fw-bold text-primary">เมนูทั้งหมด</h5>
              <a href="/" className="mb-1 text-dark text-decoration-none">
                <small>{global.i18[locale]?.["หน้าแรก"] || "หน้าแรก"}</small>
              </a>
              <hr className="my-1"/>
              <a href="/about" className="mb-1 text-dark text-decoration-none">
                <small>{global.i18[locale]?.["เกี่ยวกับบริษัท"] || "เกี่ยวกับบริษัท"}</small>
              </a>
              <hr className="my-1"/>
              <a href="/product" className="mb-1 text-dark text-decoration-none">
                <small>{global.i18[locale]?.["สินค้า"] || "สินค้า"}</small>
              </a>
              <hr className="my-1"/>
              <a href="/standards-and-research" className="mb-1 text-dark text-decoration-none">
                <small>{global.i18[locale]?.["มาตรฐานและงานวิจัย"] || "มาตรฐานและงานวิจัย"}</small>
              </a>
              <hr className="my-1"/>
              <a href="/customer" className="mb-1 text-dark text-decoration-none">
                <small>{global.i18[locale]?.["ลูกค้า"] || "ลูกค้า"}</small>
              </a>
              <hr className="my-1"/>
              <a href="/contact" className="mb-1 text-dark text-decoration-none">
                <small>{global.i18[locale]?.["ติดต่อเรา"] || "ติดต่อเรา"}</small>
              </a>
              <hr className="my-1"/>
          </div>
          <div className="col-12 col-sm-6 col-lg-3 mb-2">
            <h5 className="mb-2 fw-bold text-primary">ผลิตภัณฑ์แนะนำ</h5>
            {this.state.data_product.map((item, i) => (
              <div>
              <a
              href={"/detail-product?id=" + item.uid}
                key={`footer-product-${i}`}
                className="mb-1 text-dark text-decoration-none"
              >
                  <small>
                    {item?.[`${locale}_product_name`] ||
                      item?.th_product_name ||
                      "ไม่มีชื่อสินค้า"}
                  </small>
              </a>
              <hr className="my-1"/>
              </div>
            ))}
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-2">
            <h5 className="mb-2 fw-bold text-primary">ติดต่อเราได้ที่</h5>
              <div className="mb-1 text-dark text-decoration-none">
                <span className="icon me-2 fw-bold text-primary">{"\uf1ad"}</span><small>{name_contact_1}</small>
              </div>
              <hr className="my-1"/>
              <div className="mb-1 text-dark text-decoration-none">
                <span className="icon me-2 fw-bold text-primary">{"\uf015"}</span><small>{address_contact_1}</small>
              </div>
              <hr className="my-1"/>
              <a href={"mailto:" + email_contact_1} className="mb-1 text-dark text-decoration-none">
                <span className="icon me-2 fw-bold text-primary">{"\uf0e0"}</span><small>{email_contact_1}</small>
              </a>
              <hr className="my-1"/>
              <div className="d-flex">
                <span className="icon me-2 fw-bold text-primary">{"\uf095"}</span><span className="text-secondary">{phone_contact_1.split(",").map((phone, index) => <a href={`tel:${phone}`} key={index} style={{color: "black", textDecoration: "none",fontSize: 13}}>{phone}{index !== phone_contact_1.split(",").length - 1 ? ", " : ""}</a>)}</span>
              </div>
              <hr className="my-1"/>
              <div className="mb-1 text-dark text-decoration-none">
                <span className="icon me-2 fw-bold text-primary">{"\uf1ac"}</span><small>{fax_contact_1}</small>
              </div>
              <hr className="my-1"/>
          </div>
          <div className="col-12 text-center mb-4">
            <small>
              @2025 "Pantheon Tech" All rights reserved. v.{global.version}
            </small>
          </div>
        </div>
      </div>
      </div>
    );
  }
}
